import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorScreen } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { MissingUser } from './Constants.js';
import { PlayersView } from './components/PlayersView.js';
export function PlayersApp(props) {
    const { selection: selectedUserId, changeSelection: changeUserSelection } = props;
    const appContext = useAppContext();
    if (appContext.getEffectivePermissionLevel() !== 'game-master') {
        return _jsx(UnauthorizedErrorScreen, {});
    }
    const users = appContext.getAllUsers();
    let selectedPlayer;
    if (selectedUserId === undefined) {
        selectedPlayer = users.length === 0 ? undefined : users[0];
    }
    else {
        selectedPlayer = users.find((u) => u.id === selectedUserId) ?? MissingUser;
    }
    const gmContext = appContext;
    return (_jsx(PlayersView, { players: users, selection: selectedPlayer, changeSelection: (player) => changeUserSelection(player?.id), addPlayer: gmContext.addPlayer, deletePlayer: gmContext.deletePlayer }));
}
function UnauthorizedErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            'Access Denied',
            'The Players app is only accessible to Game Masters.',
            'Please contact your GM if you believe this is an error.',
        ] }));
}
//# sourceMappingURL=PlayersApp.js.map